import styled from "styled-components";
import {
    getMaxA,
    getMaxB, getMaxDA, getMaxDB,
    getMaxOfMin,
    getMaxX,
    getMaxY,
    getMinA,
    getMinB,
    isDeg,
    validateInput
} from "../helper/function";
import {MAX_B, MIN_DEGREE, TYPE_DECOUPE} from "../helper/constants";

const Input = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  min-height: 70px;

  & input {
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: start;
    border-radius: 8px;
    border-color: #E4E4F4 !important;
    color: #5F5D5E !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    padding-right: 5px;
    padding-left: 56px;
    outline: none !important;
  }

  & input:focus {
    border-color: #37CC74 !important;
  }

  &::after {
    content: ${(props) => props.isDeg ? `"°"` : `"mm"`};
    position: absolute;
    top: 8px;
    right: 25px;
    transition: all .05s ease-in-out;
    color: #5F5D5E !important;
    font-size: 16px !important;
    font-weight: 600 !important;
  }

  &.big::after {
    font-size: 30px !important;
  }

  &::before {
    content: ${(props) => `"${props.inputName}"`};
    position: absolute;
    height: 44px;
    width: 44Px;
    left: 0;
    top: 0;
    background-color: #E4E4F4;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all .05s ease-in-out;
    color: #144344;
    font-size: 16px;
    font-weight: 600;
  }

  & .suggest {
    display: none;
    opacity: 0;
  }

  & input:focus + .suggest {
    transition: opacity 200ms, display 200ms;
    display: block;
    opacity: 1;
  }

  &[v="error"]::before {
    background-color: #d34343 !important;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    color: #fff !important;
  }


  &[v="validated"]::before {
    background-color: #37CC74 !important;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    color: #fff;
  }
`;

function SuggestMessage({min, max, unit}) {
    return (
        <span>Entre: <strong>{min}</strong> et <strong>{max}</strong> {unit}</span>
    )
}

function SuggestDiametres() {
    return (
        <span>ø disponibles: 6/8/10/11/12/14/16/20/26/30/40/45/50/60/65/70/75</span>
    )
}

export default function DimensionInput({type, inputName, currentValue, handleInputChange, form, dimension, thickness, material, shade}) {
    const handleChange = (e) => {
        handleInputChange(inputName, e.target.value );
    }


    const getConstraintFromInputName = (inputName) => {
        if (type === TYPE_DECOUPE) {
            if (inputName === "A") {
                let thisMax = getMaxA(shade);
                if (form === 'anneau' || form === 'disque') {
                    thisMax = getMaxB(shade);
                }
                return <SuggestMessage min={getMinA(shade)} max={thisMax} unit={"mm"}/>;
            }
            if (inputName === "B") {
                return <SuggestMessage min={getMinB(shade)} max={getMaxB(shade)} unit={"mm"}/>;
            }
            if (inputName === "dA") {
                let min = 10;
                let max = getMaxDA(shade, dimension);
                return <SuggestMessage min={min} max={max} unit={"mm"}/>;
            }
            if (inputName === "dB") {
                let min = 10;
                let max = getMaxDB(shade, dimension);
                return <SuggestMessage min={min} max={max} unit={"mm"}/>;
            }
            if (inputName === "x") {
                if (form === 'mv-rect-percage' || form === 'mv-rect-double' || form === 'mv-rect-triple') {
                    return <SuggestDiametres />
                } else {
                    let min = thickness;
                    let max = getMaxX(shade, dimension);
                    if (form === 'cadre-cr' || form === 'rect-enc' || form === 'trapeze') {
                        max = getMaxX(shade, dimension, true);
                    }
                    if (form === 'cadre-cc' || form === 'anneau') {
                        max = getMaxOfMin(shade, dimension, true);
                    }
                    if (form === 'croix' || form === 'rect-coin-b' || form === 'rect-percage') {
                        max = getMaxX(dimension, true) / 2
                    }
                    if (form === 'bpmv_arc') {
                        min = 10;
                        max = dimension?.A ? dimension.A / 2 : 1000;
                    }
                    return <SuggestMessage min={min} max={max} unit={"mm"}/>;
                }
            }
            if (inputName === "y") {
                // let min = thickness;
                let min = 20;
                let max = getMaxY(shade, dimension);
                if (form === 'cadre-cr' || form === 'rect-enc') {
                    //max = getMaxOfMin(shade, dimension, true);
                    max = getMaxY(shade, dimension,true)
                }
                if (form === 'mv-rect-percage' || form === 'croix' || form === 'rect-coin-b' || form === 'rect-percage') {
                    max = getMaxY(shade, dimension,true) / 2
                }
                return <SuggestMessage min={min} max={max} unit={"mm"}/>;
            }
        } else {
            let min = thickness <= 2 ? getMinB(shade) : 20;
            if (inputName === "A") {
                return `Total largeur entre ${min} et ${getMaxB(shade)}`;
            }
            if (inputName === "B") {
                return `Total largeur entre ${min} et ${getMaxB(shade)}`;
            }
            if (inputName === "C") {
                return `Total largeur entre ${min} et ${getMaxB(shade)}`;
            }
            if (inputName === "D") {
                return `Total largeur entre ${min} et ${getMaxB(shade)}`;
            }
            if (inputName === "E") {
                return `Total largeur entre ${min} et ${getMaxB(shade)}`;
            }
            if (["1", "2", "3", "4"].includes(inputName)) {
                return <SuggestMessage min={MIN_DEGREE} max={180} unit={"°"} />;
            }
            if (inputName === "P") {
                return <SuggestMessage min={getMinA(shade)} max={getMaxA(shade)} unit={"mm"} />;
            }
        }
    }

    const getValidateValue = () => {
        if (!dimension || (dimension && !dimension[inputName])) {
            return '';
        } else {
            return validateInput(dimension, inputName, thickness, type, form, shade) ? "validated" : "error";
        }
    }
    return (
      <Input inputName={inputName} isDeg={isDeg(inputName)} className={isDeg(inputName) ? "big" : ""} v={getValidateValue()} >
          <input type="number" value={currentValue} onChange={handleChange} placeholder={inputName === "P" ? 'Profondeur' : ''}/>
          <div className="suggest">
              {getConstraintFromInputName(inputName)}
          </div>
      </Input>
    );
}